<template>
    <n-collapse-item :title="question" :name="_uid">
        <RichText :text="answer" />
    </n-collapse-item>
</template>

<script setup lang="ts">
defineProps<{ question: string; answer: string; _uid: string }>();
</script>
